import React, { useEffect, useMemo, useState } from "react";
import PersistentDrawerLeft from "../../../reusable/admin/Main";
import { FormDiv, ButtonCust } from "../styles/Product.style";
import { Form, Button, Table, Input } from "antd";
import { Box, Typography } from "@mui/material";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { BUTTON_STYLE } from "../../../../constants/style";
import { users_list } from "../services/users";
import "../styles/user.css";

const styletabletext = {
  fontSize: "14px",
};

interface Users {
  id: number;
  fullName: string;
  mobileNo: number;
  email: any;
  addressInfo: any;
  GSTnumber: any;
}

const Userlist = () => {
  const navigate = useNavigate();

  const [dataUserSource, setDataUserSource] = useState<Users[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [nameFilter, setNameFilter] = useState<string>("");
  const [mobileFilter, setMobileFilter] = useState<string>("");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response: any = await users_list({});
        setDataUserSource(response.data);
      } catch (error) {
        setDataUserSource([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const filteredDataUserSource = useMemo(() => {
    return dataUserSource.filter((user) => {
      const fullName = user.fullName ? user.fullName.toLowerCase() : "";
      const mobileNo = user.mobileNo ? String(user.mobileNo) : "";

      const isNameMatch = fullName.includes(nameFilter.toLowerCase());
      const isMobileMatch = mobileNo.includes(mobileFilter);

      return isNameMatch && isMobileMatch;
    });
  }, [dataUserSource, nameFilter, mobileFilter]);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text: string | number) => (
        <Typography style={styletabletext}>{text}</Typography>
      ),
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
      render: (text: string) => (
        <Typography style={styletabletext}>{text}</Typography>
      ),
    },
    {
      title: "Mobile No",
      dataIndex: "mobileNo",
      key: "mobileNo",
      render: (text: string) => (
        <Typography style={styletabletext}>{text}</Typography>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text: string) => (
        <Typography style={styletabletext}>{text}</Typography>
      ),
    },
    {
      title: "Address Info",
      dataIndex: "addressInfo",
      key: "addressInfo",
      render: (text: string) => (
        <Typography style={styletabletext}>{text}</Typography>
      ),
    },
    {
      title: "GST No",
      dataIndex: "GSTnumber",
      key: "GSTnumber",
      render: (text: string) => (
        <Typography style={styletabletext}>{text}</Typography>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: { id: number }) => (
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => navigate(`/admin/userListUpdate/${record.id}`)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handleCreate = () => {
    navigate(`/admin/user`);
  };

  return (
    <FormDiv>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 2,
        }}
      >
        <Typography variant="h6">User List</Typography>
        <ButtonCust onClick={handleCreate} sx={BUTTON_STYLE}>
          Add
        </ButtonCust>
      </Box>

      {/* Filter Section */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          marginBottom: 2,
          flexWrap: "wrap",
        }}
      >
        <Input
          placeholder="Search by name"
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
          allowClear
          style={{ width: 250 }}
        />

        <Input
          placeholder="Search by mobile number"
          value={mobileFilter}
          onChange={(e) => setMobileFilter(e.target.value)}
          allowClear
          style={{ width: 250 }}
        />
      </Box>

      {/* Table Section */}
      <Table
        dataSource={filteredDataUserSource}
        columns={columns}
        bordered
        rowKey="id"
        pagination={{ pageSize: 10 }}
        size="small"
        loading={loading}
        className="tableuserlistbg"
        style={{ border: "1px solid #ddd", borderRadius: "8px" }}
      />
    </FormDiv>
  );
};

export default Userlist;